import { navigate } from '../lib/router.ts';

/**
 * Persistent "artifact ready" affordance for phase `analysis` (docs/specs/app.md, "Artifact
 * exploration (v1.1)" reachability addendum — found in production: the artifact route existed
 * but nothing linked to it once a run finished, so a user who never saw the URL scheme had no
 * way in). Mirrors PhaseBanner's layout; shown instead of it once the run is no longer `running`.
 */
export function ArtifactBanner({ sessionId, runId }: { sessionId: string; runId: string }): JSX.Element {
  return (
    <div className="panel artifact-banner">
      <span>The comparison artifact is ready.</span>
      <div className="artifact-banner-actions">
        <button className="btn primary sm" onClick={() => navigate({ view: 'artifact', sessionId, runId })}>
          View artifact →
        </button>
        <button className="btn sm" onClick={() => navigate({ view: 'run', sessionId, runId })}>Run details</button>
      </div>
    </div>
  );
}
